import { config } from "../config";

// Base API URL from config
const API_URL = config.apiUrl;

// Helper function to properly construct URLs without double slashes
const buildUrl = (base: string, path: string): string => {
  const cleanBase = base.replace(/\/+$/, ""); // Remove trailing slashes
  const cleanPath = path.replace(/^\/+/, ""); // Remove leading slashes
  return `${cleanBase}/${cleanPath}`;
};

// Generic API request function
export const apiRequest = async (
  endpoint: string,
  method: string = "GET",
  data: any = null
) => {
  try {
    const headers: HeadersInit = {
      "Content-Type": "application/json",
    };

    const options: RequestInit = {
      method,
      headers,
    };

    if (data && (method === "POST" || method === "PUT" || method === "PATCH")) {
      options.body = JSON.stringify(data);
    }

    const url = buildUrl(API_URL, endpoint);
    const response = await fetch(url, options);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error(`API request error (${method} ${endpoint}):`, error);
    throw error;
  }
};

// Convenience methods
export const get = (endpoint: string) => apiRequest(endpoint, "GET");
export const post = (endpoint: string, data: any) =>
  apiRequest(endpoint, "POST", data);
export const put = (endpoint: string, data: any) =>
  apiRequest(endpoint, "PUT", data);
export const patch = (endpoint: string, data: any) =>
  apiRequest(endpoint, "PATCH", data);
export const del = (endpoint: string) => apiRequest(endpoint, "DELETE");
